import React from "react";
import { connect } from "react-redux";

import "../../style.css";

import Access from "../../../../components/Access";
import Page from "../../../../components/Page";
import { Link } from "react-router-dom";
import Configuration, { translations } from "../../../../config";
import Overview from "../../../../components/Overview";
import Form from "../../../../components/Form";
import Icon from "../../../../components/Icon";
import { createDomains, getDomains, patchDomains } from "../../actions/Domains";
import { getCurrentArticles } from "../../../../actions/Users";
import { hostExists } from "../../../../actions/Billings";
import { message } from "../../../../actions";
import ReactGA from "react-ga";
import { getOrganizationsOverview } from "../../../questionnaires/actions/Organizations";
import RoleManagement from "../../../../containers/RoleManagement";
import { getUpdatedValues } from "../../../../components/HandleHelper";

const mapStateToProps = ( state ) =>
{
	return {
		articles: state.articles,
		domains: state.domains,
		organizations: state.organizations,
		user: state.user
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		getDomains: () =>
		{
			dispatch( getDomains() );
			dispatch( getCurrentArticles() );
		},
		createDomains: ( a_formData ) =>
		{
			dispatch( createDomains( a_formData ) );
		},
		patchDomains: ( a_formData ) =>
		{
			dispatch( patchDomains( a_formData ) );
		},
		hostExists: ( a_host ) =>
		{
			return dispatch( hostExists( a_host ) );
		},
		getOrganizationsOverview: () =>
		{
			dispatch( getOrganizationsOverview() );
		},
		message: ( a_message, a_type, a_timeout ) =>
		{
			dispatch( message( a_message, a_type, a_timeout ) );
		}
	};
};

/**
 * Fragebogenkomponente der GUI
 */
class LandingPage extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.state = {
			data_loaded: false,
			domains_count: 1,
			users_count: 0,
			contract_duration: 1
		};
		
		this.handleAddDomains = this.handleAddDomains.bind( this );
		this.handleEdit = this.handleEdit.bind( this );
		
	} // constructor(...)
	
	/**
	 * Domains und Organisationen laden
	 */
	componentDidMount()
	{
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.pageview( translations.de_DE.routes.registration );
		}
		
		if ( this.props.domains.length === 0 && Access.isPermitted( this.props.user, [ "get_domains" ] ) )
		{
			this.props.getDomains();
			
			if ( Access.isPermitted( this.props.user, [ "get_organizations" ] ) )
			{
				this.props.getOrganizationsOverview();
			}
		}
	} // function componentDidMount()
	
	/**
	 * Domains und Organisationen laden, falls noch nicht geschehen
	 *
	 * @param prevProps
	 * @param prevState
	 */
	componentDidUpdate( prevProps, prevState )
	{
		if ( !this.state.data_loaded && this.props.domains.length === 0 && Access.isPermitted( this.props.user, [ "get_domains" ] ) )
		{
			// Verhindert das ständige Laden der Domains, wenn keine vorhanden sind.
			this.setState( { data_loaded: true } );
			
			this.props.getDomains();
			
			if ( Access.isPermitted( this.props.user, [ "get_organizations" ] ) )
			{
				this.props.getOrganizationsOverview();
			}
		}
		
	} // function componentDidUpdate(...)
	
	/**
	 * Aktion: Neue Domain hinzubuchen
	 *
	 * @param {Object} a_formData Domaindaten
	 */
	handleAddDomains( a_formData )
	{
		this.props.createDomains( { ...a_formData, start_date: a_formData.start_date.toLocaleDateString() } );
		
	} // function handleAddDomains(...)
	
	/**
	 * Aktion: Domain kündigen oder Kurzbeschreibung ändern
	 *
	 * @param {Object} a_currentValues  Aktuelle Domaindaten
	 * @param {Object} a_newValues      Neue Domaindaten
	 */
	handleEdit( a_currentValues, a_newValues )
	{
		if ( JSON.stringify( a_currentValues ) !== JSON.stringify( a_newValues ) )
		{
			const updatedValues = getUpdatedValues( a_currentValues, a_newValues );
			
			if ( Object.keys( updatedValues ).length === 0 )
			{
				return this.props.message( "Es liegen keine Änderungen vor." );
			}
			
			if ( updatedValues.start_date )
			{
				const { domains, user } = { ...this.props };
				
				const domainExists = Object.keys( domains ).filter(
					a_key =>
					{
						// Domains der eigenen Organisation filtern
						return domains[ a_key ].id !== a_newValues.id &&
							domains[ a_key ].organization_id === user.organization.id
							&& ( domains[ a_key ].expiring_date === null || new Date( domains[ a_key ].expiring_date ) > a_newValues.start_date )
							&& domains[ a_key ].domain_name === a_newValues.domain_name;
					}
				).length > 0;
				
				if ( domainExists )
				{
					return this.props.message( "Die Domain ist in den Zeitraum bereits vorhanden.", "error" );
				}
			}
			
			updatedValues[ "article_id" ] = a_currentValues.article_id;
			
			// Nur die Änderungen aktualisieren
			this.props.patchDomains( updatedValues );
		}
		
	} // function handleEdit(...)
	
	/**
	 * Statusreport zurückgeben
	 *
	 * @param {Object} a_currentValues  Aktuelle Domaindaten
	 */
	handleReport( a_currentValues )
	{
		// TODO Report erzeugen
		this.props.message( "Sorry soon", "info", 5000 );
		
	} // function handleReport(...)
	
	/**
	 * Mindestdatum zurückgeben
	 *
	 * @param {Object} a_currentValues  Aktuelle Domaindaten
	 */
	getMinDate( a_currentValues )
	{
		const { domains } = { ...this.props };
		let date;
		
		Object.keys( domains ).forEach(
			a_key =>
			{
				if ( domains[ a_key ].organization_id === a_currentValues.organization_id &&
					domains[ a_key ].domain_name === a_currentValues.domain_name &&
					( !date || date < new Date( domains[ a_key ].expiring_date ) ) )
				{
					date = new Date( domains[ a_key ].expiring_date );
				}
			}
		);
		
		return date;
		
	} // function getMinDate(...)
	
	render()
	{
		const { domains, user, message, organizations } = { ...this.props };
		
		const articleId = `${this.state.domains_count}-${this.state.users_count}-${this.state.contract_duration}`;
		const price = this.props.articles.hasOwnProperty( articleId )
			? this.props.articles[ articleId ]
			: null;
		const page = [];
		
		// Dashboard für Gäste
		if ( Access.isPermitted( user, [ "guest_user_permissions" ], true ) )
		{
			return <Page key={"domains"} title={`Herzlich Willkommen bei ${translations.de_DE.words.appName}!`} pageUrl={"/"}>
				<div className={"col s12"}>
					<Link to={translations.de_DE.routes.registration}>
						<div className={"btn"}>Los geht´s!</div>
					</Link>
				</div>
			</Page>;
		}
		
		// Dashboard für RollenAdmin
		if ( Access.isPermitted( user, [ "get_roles", "get_permissions" ], true ) )
		{
			page.push( <RoleManagement key={"RoleManagement"}/> );
		}
		
		// Dashboard für FakturaAdmin
		if ( Access.isPermitted( user, [ "get_articles" ], true ) )
		{
			page.push( <Page key={"faktura"} title={"Dashboard"} pageUrl={"/"}>
				<div className={"col s12"}>
					<h4>Rechnungsverwaltung</h4>
					<p/>
				</div>
			</Page> );
		}
		
		// Dashboard für OrgaAdmin
		if ( Access.isPermitted( user, [ "get_domains" ], true ) || Access.isPermitted( user, [ "super_user_permissions" ], true ) )
		{
			const today = new Date();
			let userDomainOverview = [], customerDomainOverview = [];
			
			const triggerAddFields = [
				{
					name: "name",
					title: "Domainname",
					type: "text",
					required: true,
					cleared: true,
					className: "col s12"
				},
				{
					name: "description",
					title: "Kurzbeschreibung",
					type: "text",
					cleared: true,
					className: "col s12"
				},
				{
					name: "start_date",
					title: "Auswertungsbeginn",
					type: "date",
					min: today,
					inline: true,
					required: true,
					className: "col s12 l8 margin-bottom"
				},
				{
					name: "price",
					type: "hidden"
				}
			];
			
			const listFields = [
				{
					name: "domain_name",
					title: "Domain",
					sortable: true,
					className: "col s12 m5 l4 xl6"
				},
				{
					name: "start_date",
					title: "Auswertungsbeginn",
					sortable: true,
					className: "col s6 m4 l4 xl3"
				},
				{
					name: "price",
					title: "Preis (zzgl. 19% USt.)",
					sortable: true,
					className: "col s6 m3 l4 xl2"
				},
				{
					name: "domain_description",
					title: "Kurzbeschreibung",
					sortable: true,
					className: "col s12 m5 l4 xl6",
					hideOnEmpty: true
				},
				{
					name: "expiring_date",
					title: "Gekündigt zum",
					sortable: true,
					className: "col s6 m4 l4 xl3",
					hideOnEmpty: true
				}
			];
			
			Object.keys( domains ).forEach(
				a_id =>
				{
					const domain = { ...domains[ a_id ] };
					domain[ "start_date" ] = domain.start_date && new Date( domain.start_date ).toLocaleString( Configuration.location ).split( "," )[ 0 ];
					domain[ "expiring_date" ] = domain.expiring_date && new Date( domain.expiring_date ).toLocaleString( Configuration.location ).split( "," )[ 0 ];
					domain[ "price" ] = domain.price && parseFloat( domain.price ).toLocaleString( Configuration.location, Configuration.priceString ) + " Euro";
					
					if ( domain.organization_id === user.organization.id )
					{
						userDomainOverview.push( domain );
					}
					else if ( Access.isPermitted( user, [ "get_restricted_domains" ] ) && Object.keys( organizations ).length > 0 )
					{
						domain[ "organization" ] = organizations[ domain.organization_id ];
						domain[ "organization_name" ] = domain.organization && domain.organization.name;
						customerDomainOverview.push( domain );
					}
				}
			);
			
			const trigger = [
				{
					key: "getReport",
					icon: "getReport",
					iconTitle: "Bericht anzeigen",
					iconClassName: "white secondary-color-text hover-primary-color hover-white-text",
					permissions: [ "get_domain_report" ],
					onlyActionButton: true,
					onClick: ( a_currentValues, a_newValues ) => this.handleReport( a_currentValues, a_newValues )
				},
				{
					key: "editDescription",
					icon: "edit",
					submitButtonText: "Ändern",
					title: "Kurzbeschreibung ändern",
					iconTitle: "Kurzbeschreibung ändern",
					iconClassName: "white primary-color-text hover-primary-color hover-white-text",
					permissions: [ "patch_domain" ],
					formFields: [
						{
							name: "domain_description",
							title: "Kurzbeschreibung",
							type: "text",
							required: true,
							className: "col s12"
						}
					],
					onClick: ( a_currentValues, a_newValues ) => this.handleEdit( a_currentValues, a_newValues )
				},
				{
					key: "editContract",
					icon: "editContract",
					submitButtonText: "Ändern",
					title: "Vertragsbeginn ändern",
					iconTitle: "Vertragsbeginn ändern",
					iconClassName: "white primary-color-text hover-primary-color hover-white-text",
					permissions: [ "super_user_permissions" ],
					formFields: [
						{
							name: "start_date",
							title: "Auswertungsbeginn",
							type: "date",
							inline: true,
							required: true,
							className: "col s12",
							min: a_values => this.getMinDate( a_values )
						}
					],
					disableOnNotEmpty: "expiring_date",
					onClick: ( a_currentValues, a_newValues ) => this.handleEdit( a_currentValues, a_newValues )
				},
				{
					key: "cancelContract",
					icon: "cancelContract",
					submitButtonText: "Domain kündigen",
					title: "Domain kündigen",
					iconTitle: "Domain kündigen",
					iconClassName: "white red-text hover-red hover-white-text",
					permissions: [ "patch_domain" ],
					formFields: [
						{
							name: "domain_name",
							title: "Domainname",
							type: "text",
							disabled: true,
							cleared: true,
							className: "col s12"
						},
						{
							name: "expiring_at",
							title: "Auswertungsenddatum",
							type: "date",
							dateFormat: "MM.yyyy",
							startFieldName: "start_date",
							toAddDate: "EndOfMonth",
							required: true,
							cleared: true,
							className: "col s12"
						}
					],
					disableOnNotEmpty: "expiring_date",
					onClick: ( a_currentValues, a_newValues ) => this.handleEdit( a_currentValues, a_newValues )
				}
			];
			
			page.push( <Page key={"domains"}
			                 title={`Herzlich Willkommen bei ${translations.de_DE.words.appName}!`}
			                 pageUrl={"/"}
			                 before={<section className={"unset-margin"}>
				                 <div className={"col s12"}>
					                 <div className={"col s6 m8 l9 unset-padding"}>
						                 <h6 className={"col s12 m8 unset-padding margin-top"}>Ihre Domains im Überblick</h6>
					                 </div>
					                 <Access permissions={[ "get_domains" ]}>
						                 <div className={"col s6 m4 l3 tRight unset-padding-right"}>
							                 <Form
								                 id={`form_add_domains`}
								
								                 modalTitle={"Domain hinzubuchen"}
								                 modalClass={"confirm tLeft"}
								                 modalTrigger={
									                 <button title={"Domain hinzubuchen"} className={"btn btn-middle icon-shadow unset-margin"}>
										                 <Icon iconName={"add"}/>
										                 <span>Domain hinzubuchen</span>
									                 </button>
								                 }
								
								                 errorMessage={( a_message, a_type, a_timeout ) => message( a_message, a_type, a_timeout )}
								                 onSubmit={( a_event, a_formData ) => this.handleAddDomains( { ...a_formData, article_id: articleId } )}
								                 submitValue={[
									                 <Icon size={18} verticalAlign={"bottom"} key={`form-payment-icon`} iconName={"payment"}/>,
									                 <span key={`form-payment-text`}>Kostenpflichtig bestellen</span>
								                 ]}
								
								                 fields={triggerAddFields}
								                 additionalFormHtml={
									                 <div className="col s12 l4 price tRight">
										                 <label className="padding-bottom primary-color-text">Preis pro Monat</label>
										                 <span className="value sub">
												               {parseFloat( ( price * 1.19 ).toString() ).toLocaleString( Configuration.location, Configuration.priceString )}
											               </span>
										                 <span className="additional">Euro</span>
										
										                 <label className="primary-color-text">inkl. 19% USt.</label>
									                 </div>
								                 }
								                 values={{ start_date: today, price: parseFloat( price ).toString() }}
								
								                 validator={
									                 ( a_values ) =>
									                 {
										                 const domainExists = Object.keys( domains ).filter(
											                 a_key =>
											                 {
												                 // Domains der eigenen Organisation
												                 return domains[ a_key ].organization_id === user.organization.id
													                 && ( domains[ a_key ].expiring_date === null || new Date( domains[ a_key ].expiring_date ) > a_values.start_date )
													                 && domains[ a_key ].domain_name === a_values.name;
											                 }
										                 ).length > 0;
										
										                 if ( domainExists )
										                 {
											                 this.props.message( "Die Domain ist bereits vorhanden.", "error" );
											                 return false;
										                 }
										
										                 return this.props.hostExists( a_values.name );
									                 }
								                 }
							                 />
						                 </div>
					                 </Access>
				                 </div>
			                 </section>}>
				{
					Object.keys( userDomainOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Domains"}
						          subTitle={`(${Object.keys( userDomainOverview ).length})`}
						          list={userDomainOverview}
						          sortBy={"domain_name"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_domains" ]}
						          listFields={listFields}
						          trigger={trigger}
						          expanded
						/>
					</div>
				}
				{
					Object.keys( customerDomainOverview ).length > 0 &&
					<div className={"col s12"}>
						<Overview title={"Kundendomains"}
						          subTitle={`(${Object.keys( customerDomainOverview ).length})`}
						          list={customerDomainOverview}
						          groupBy={"organization"}
						          sortBy={"domain_name"}
						          className={"hidden-buttons unset-margin"}
						          classNameItem={"white-grey"}
						          classNameDataBlock={"col s12 l10 unset-padding"}
						          classNameTriggerBlock={"col s12 l2 tRight"}
						          permissionsToShow={[ "get_domains" ]}
						          listFields={listFields}
						          trigger={trigger}
						/>
					</div>
				}
			</Page> );
		}
		
		return page;
		
	} // function render()
	
} // class

LandingPage = connect(
	mapStateToProps,
	mapDispatchToProps
)( LandingPage );

export default LandingPage;
